import React, { useState, useEffect } from "react";

import Headline from "../../../atoms/headline";
import { Link } from "@quintype/components";
import ScrollSnap from "../../../molecules/ScrollSnap";
import SingleStrokeRightArrow from "../../../atoms/icons/single-stroke-right-arrow";
import Cardimage from "../../../atoms/cardimage";

import "./budget-widget.m.css";
import "../../../story-templates/story-elements/slide-show/slideshow-element.m.css";

function BudgetWidget({ story, embed }) {
  const { slug, headline } = story;

  const [isMobile, setMobile] = useState(false);
  const [showSlider, setShowSlider] = useState(false);

  useEffect(() => {
    if (window && window.innerWidth < 767) {
      setMobile(true);
    } else {
      setMobile(false);
    }

    setTimeout(() => {
      setShowSlider(true);
    }, 200);
  }, []);

  const sliderItems = [
    <div styleName="election-widget-wrapper">
      <div dangerouslySetInnerHTML={{ __html: embed }}></div>
    </div>,
    <div styleName="slider-image-wrapper">
      <Link href={`/${slug}`}>
        <Cardimage story={story} aspectRatio={[2, 1]} imageType="image2x1" showVideoIcon={true} />
      </Link>
    </div>
  ];

  return (
    <div styleName="main-wrapper">
      <Link href={`/${slug}`}>
        <div styleName="heading">
          <Headline text={headline} headerType={6} headerLevel={1} story={story} />
        </div>
      </Link>

      <div styleName="wrapper">
        {showSlider && embed ? (
          <ScrollSnap
            leftArrow={
              <div
                className="arrow-wrapper"
                style={{ top: isMobile ? "59px" : "145px", left: isMobile ? "-37px" : "-15px", position: "absolute" }}
              >
                <SingleStrokeRightArrow />
              </div>
            }
            rightArrow={
              <div
                className="arrow-wrapper"
                style={{ top: isMobile ? "59px" : "145px", right: isMobile ? "-37px" : "-15px", position: "absolute" }}
              >
                <SingleStrokeRightArrow />
              </div>
            }
          >
            {sliderItems.map((item, index) => (
              <div key={index}>
                <div id="slideshow-image-wrapper">{item}</div>
              </div>
            ))}
          </ScrollSnap>
        ) : (
          <div styleName="temp-fallback">
            <Cardimage story={story} aspectRatio={[2, 1]} imageType="image2x1" />
          </div>
        )}
      </div>
    </div>
  );
}

export default BudgetWidget;
